<template>
  <list-monev :gelombang-fsp="mGelombang" />
</template>

<script>
import ListMonev from '@views/instansi/diklat/iht/Index';
import { mapState } from 'vuex';
export default {
  name: 'IndexFsp',
  components: { ListMonev },
  computed: {
    ...mapState('preferensi', {
      paGelombang: (state) => state.data?.pelatih_ahli_gelombang ?? [],
    }),

    mGelombang() {
      const gelombangs = [...[], ...this.paGelombang];
      return gelombangs.sort((a, b) => b - a);
    },
  },
};
</script>

<style scoped></style>
